import moment from 'moment';
import { storeTranslations } from '../redux/actions/globalizationAction';
import store from '../redux/store';
import {
  GLOBALIZATION_SYSTEM_ID,
  GLOBALIZATION_BASE_API_URL,
  GLOBALIZATION_GET_TERMS_AND_TRANSLATIONS_BY_TAG_ENDPOINT,
} from '../constants/globalizationConstants';
import httpService from './httpService';

const globalizationService = () => {
  const getTermAndTranslationsByTag = async ({
    systemId, tag, culture, productId, product,
  }) => {
    const { get } = httpService();
    const params = {
      SystemId: systemId, // int
      Tag: tag, // string
      Culture: culture, // string
      ProductId: productId, // int
      Product: product, // string
    };

    const result = await get({
      url: GLOBALIZATION_BASE_API_URL
    + GLOBALIZATION_GET_TERMS_AND_TRANSLATIONS_BY_TAG_ENDPOINT,
      data: params,
    });

    return result;
  };

  // Requisição das traduções no idioma atualmente selecionado
  // se tiver e o tempo do cache do cache não tiver acabado
  // não deve ser feita uma nova requisição
  const getDataTermAndTranslationsByTag = async (culture, translationsCache, lastCacheTime) => {
    const currentUserLanguage = localStorage.getItem('userLanguage');
    const timeNow = new Date().getTime();
    const cacheTimeNow = moment(timeNow).format('YYYY-MM-DD hh:mm:ss');
    const lastCacheTimeSaved = lastCacheTime ? moment(lastCacheTime).format('YYYY-MM-DD hh:mm:ss') : null;
    const expiresCacheTime = lastCacheTime ? moment(lastCacheTime).add(1, 'hours').format('YYYY-MM-DD hh:mm:ss') : null;

    const params = {
      systemId: GLOBALIZATION_SYSTEM_ID,
      tag: 'Global',
      culture: culture || currentUserLanguage,
    };

    // Verifica os dados em cache para fazer ou não a requisição da tradução no idioma atual
    // Se já houver no cache traduções do idioma selecionado, não é feita nova requisição
    // Mas se feita após 1 hora desde o último cache salvo, é feita outra requisição
    if (
      translationsCache === []
    || translationsCache === null
    || !translationsCache[culture]
    || lastCacheTimeSaved === null
    || expiresCacheTime <= cacheTimeNow
    ) {
      // const responseJSON = await getTermAndTranslationsByTag(params);
      // const translationsList = responseJSON && responseJSON.data
      //   ? responseJSON.data.response : null;

      // Carrega todos os idiomas da aplicação ao atenticar
      // Solução para resolver demora da requisição de tradução em Produção
      // pelo servidor ser da Bélgica e demorar  muito para trazer response
      params.culture = 'pt-BR';
      const portugueseResponseJSON = await getTermAndTranslationsByTag(params);
      const portugueseTranslationsList = portugueseResponseJSON && portugueseResponseJSON.data
        ? portugueseResponseJSON.data.response : null;

      params.culture = 'en-US';
      const englishResponseJSON = await getTermAndTranslationsByTag(params);
      const englishTranslationsList = englishResponseJSON && englishResponseJSON.data
        ? englishResponseJSON.data.response : null;

      const newTranslationsCache = {
        ...translationsCache,
        // [culture || currentUserLanguage]: translationsList,
        'pt-BR': portugueseTranslationsList,
        'en-US': englishTranslationsList,
      };

      // Atualiza objeto de traduções na store (cache)
      store.dispatch(storeTranslations(newTranslationsCache, cacheTimeNow));
    }

    return translationsCache;
  };

  return {
    getTermAndTranslationsByTag,
    getDataTermAndTranslationsByTag,
  };
};

export default globalizationService;
